import { Box, IconButton } from '@mui/material';
import pinOutlinedIcon from '../../assets/pin_outlined_b3.svg';
import pinFeaturedIcon from '../../assets/pin_f_b3.svg';
import pinRecommendedIcon from '../../assets/pin_r_b3.svg';
import theme from '../../theme';

const DesignationButton = ({ designationType, onToggle, variant = 'default' }) => {
  const buttonSize = variant === 'small' ? { xs: 32, lg: 24 } : { xs: 32, md: 40 };
  const iconSize = variant === 'small' ? { xs: 20, lg: 16 } : { xs: 16, md: 24 };
  return (
    <>
      <IconButton
        disableRipple
        onClick={onToggle}
        sx={{
          width: buttonSize,
          height: buttonSize,
          border: variant === 'small' ? 'none' : `1px solid ${theme.palette.grey.line}`,
          borderRadius: 1,
        }}
      >
        <Box
          component="img"
          src={
            !designationType
              ? pinOutlinedIcon
              : designationType === 'FEATURED'
                ? pinFeaturedIcon
                : pinRecommendedIcon
          }
          alt="pin icon"
          sx={{
            width: iconSize,
            height: iconSize,
          }}
        />
      </IconButton>
    </>
  );
};

export default DesignationButton;
